import React from 'react';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { LOAD_TEMPLATE_DROPDOWN_TEST_ID } from '../../constants';
import { regexExamples } from '../regexExamples';

import { Wrapper } from './LoadTemplateStyled';

interface Props {
    onRegexTemplateChange: (regex: string, selectedTemplate: string) => void;
    selectedTemplate?: string;
}

const LoadTemplate: React.FC<Props> = ({ onRegexTemplateChange, selectedTemplate = '' }) => (
    <Wrapper>
        <DropdownMenu
            shouldRenderToParent
            placement='bottom-end'
            trigger={selectedTemplate || 'Load template'}
            testId={LOAD_TEMPLATE_DROPDOWN_TEST_ID}
        >
            <DropdownItemGroup>
                {regexExamples.map(item => (
                    <DropdownItem
                        key={item.regex}
                        onClick={() => onRegexTemplateChange(item.regex, item.label)}
                        description={item.description}
                        elemBefore={item.elemBefore}
                    >
                        {item.label}
                    </DropdownItem>
                ))}
            </DropdownItemGroup>
        </DropdownMenu>
    </Wrapper>
);

export default LoadTemplate;
